import * as React from "react";
import NewButton from "../uiMerge/newButton";
import { useNavigate } from "react-router-dom";
import { NewModal } from "../uiMerge/newModal";
import SuccessIcon from "../../assets/images/successNewIcon.svg";
import * as ROUTES from "../../constants/routes";

interface FinishSignupModalProps {
  visible: boolean;
  onCancel: () => void;
  onOk: () => void;
}

export const FinishSignupModal: React.FC<FinishSignupModalProps> = ({
  visible,
  onCancel,
  onOk,
}) => {
  const navigate = useNavigate();

  return (
    <NewModal
      isOpen={visible}
      heightClass="h-[391px]"
      colorClass="bg-black"
      showCloseButton={false}
      animationClass="grow-in"
      position="end"
      onClose={onCancel}
      onOk={onOk}
    >
      <div className=" text-white min-h-[40vh] px-[1rem] w-full flex-col flex justify-between items-center align-center">
        <div className="text-center w-full flex flex-col space-y-11 justify-center items-center flex-grow">
          <img src={SuccessIcon} className="max-w-[100px]" alt="" />

          <p className="text-2xl font-bold">
            Signup Complete And Your Pin Has Been Created Successfully!
          </p>
        </div>

        <NewButton
          variant="primary"
          fullWidth
            onClick={() => {
              if (onCancel) onCancel();
              setTimeout(() => navigate(ROUTES.HOME, { replace: true }), 100);
            }}
        >
          Go to Homepage
        </NewButton>
      </div>
    </NewModal>
  );
};